import {
	requests
}from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/ReCountry/create', params),
	update        : (params) => requests.post('/ReCountry/update', params),
	delete        : (params) => requests.getWithParams('/ReCountry/delete', params),
	restore       : (params) => requests.getWithParams('/ReCountry/restore', params),
	getPaged      : (params) => requests.getWithParams('/ReCountry/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/ReCountry/getPagedAudit', params),
	getPagedAll   : (params) => requests.getWithParams('/ReCountry/getPagedAll', params),
	getList       : (params) => requests.getWithParams('/ReCountry/getList', params)
}